// extracted by mini-css-extract-plugin
export default {"customHousing":"styles__customHousing___xIsDI"};